import { Component, OnInit, Input } from '@angular/core';
import { OperatorService } from 'src/app/services/operator.service';
import { GlobalService } from 'src/app/services/global.service';
import { TicketService } from 'src/app/services/ticket.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-waitingticket',
  templateUrl: './waitingticket.component.html',
  styleUrls: ['./waitingticket.component.css']
})
export class WaitingticketComponent implements OnInit {

  @Input() tk;
  token: string;
  ope: any;
  activeUser: any;
  comunications: Array<any> = [];
  message: boolean = true;
  operator: boolean = false;

  text: string = '';

  constructor(
    private customerService: OperatorService,
    private globals: GlobalService,
    private ticketService: TicketService,
    private activeModal : NgbActiveModal
  ) { }

    ngOnInit() {
      if(!this.token){
        this.token = this.globals.getToken();
      }
      this.activeUser = this.globals.storagedUser;
      this.checkProfile();
      this.getComunications(this.tk);
    }

    checkProfile(){
      if(this.activeUser.profile_id > 1){
        this.operator = true;
      } else {
        this.operator = false;
      }
    }

    getComunications(tk){
      this.ticketService.getTicketCommunication(this.token, tk.ticket_id).subscribe(
        res => {
          this.comunications = res;
          this.comunications.forEach((com) => {
              let date = new Date(com.createdat);
              if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
                com.createdat = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                // console.log("mese e giorno >10")
              } else {
      
                if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
                  com.createdat = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
                  // console.log("mese e giorno <10")
                } else {
      
                  if (date.getMonth() + 1 < 10) {
                    com.createdat = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear();
                    // console.log("mese <10")
                  }
      
                  if (date.getDate() < 10) {
                    com.createdat = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
                    // console.log("giorno <10")
                  }
                }
            }
          })
        },
        err => {
          console.error("Error on get communications", err);
        }
      )
    }

    messagArea(){
      if(this.message){
        this.message = false;
      } else {
        this.message = true;
      }
    }

    send(){
      this.ticketService.sendCommunication(this.token, this.tk.ticket_id, {text: this.text}).subscribe(
        res => {
          this.getComunications(this.tk);
          this.text = '';
        },
        err => {
          console.error("Error on Send comunications", err);
        }
      )
    }
    save(){
      this.ticketService.setStatus(this.token, this.tk.ticket_id, this.tk).subscribe(
        res => {
          this.close()
        },
        err => {
          console.error("Errore: ",err);
        }
      )
    }
    reloadMex(){
      this.getComunications(this.tk);
    }

    close(){
      this.activeModal.close();
    }
}
